"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var form_1 = require("../context/form");
var props_1 = require("../context/props");
var checkIsPhoneNumber_1 = __importDefault(require("../utils/checkIsPhoneNumber"));
var validatePhoneNumber_1 = __importDefault(require("../utils/validatePhoneNumber"));
var validateEmail_1 = __importDefault(require("../utils/validateEmail"));
var useValidateForm = function () {
    var _a = (0, form_1.useFormContext)(), phoneOrEmail = _a.phoneOrEmail, comment = _a.comment;
    var translate = (0, props_1.usePropsContext)().translate;
    var validateForm = (0, react_1.useCallback)(function () { return (__assign(__assign(__assign(__assign({}, (0, checkIsPhoneNumber_1.default)(phoneOrEmail) && !(0, validatePhoneNumber_1.default)(phoneOrEmail) && {
        phoneOrEmail: translate('feedbackModal.invalidPhoneNumber')
    }), !(0, checkIsPhoneNumber_1.default)(phoneOrEmail) && !(0, validateEmail_1.default)(phoneOrEmail) && {
        phoneOrEmail: translate('feedbackModal.invalidEmail')
    }), !phoneOrEmail.trim() && { phoneOrEmail: translate('feedbackModal.fieldCannotBeEmpty') }), !comment.trim() && { comment: translate('feedbackModal.fieldCannotBeEmpty') })); }, [
        phoneOrEmail,
        comment,
        translate
    ]);
    return validateForm;
};
exports.default = useValidateForm;
